export const module = {
  info: {
    name: 'voip-fusion-server',
    caption: 'voip fusion server',
    viewGroup: 'servers-modules'
  },
  vuexModules: ['api', 'state'],
  mainRoute: '/cpanel',
  // noRoutes: true,
  sideMenu: {
    notAllowedProfiles: [],
    topSeparator: false,
    caption: 'FusionPBX Servers',
    icon: 'el-icon-bank-card',
    routeName: 'module->voip-fusion-server->create',
    children: [
      {
        caption: 'Dashboard',
        icon: 'el-icon-plus',
        routeName: 'module->voip-fusion-server->dashboard'
      },
      {
        caption: 'Create Server',
        icon: 'el-icon-plus',
        routeName: 'module->voip-fusion-server->create'
      },
      {
        caption: 'List Servers',
        icon: 'el-icon-more-outline',
        routeName: 'module->voip-fusion-server->list->page',
        routeParams: { listPage: 1}
      }
    ]
  }
}

export default module
